import { render, staticRenderFns } from "./EmployeeView.vue?vue&type=template&id=0a5dd806&scoped=true&"
import script from "./EmployeeView.vue?vue&type=script&lang=ts&"
export * from "./EmployeeView.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeView.vue?vue&type=style&index=0&id=0a5dd806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5dd806",
  null
  
)

export default component.exports